import { render, staticRenderFns } from "./TableDraft.vue?vue&type=template&id=346b5c11&"
import script from "./TableDraft.vue?vue&type=script&lang=js&"
export * from "./TableDraft.vue?vue&type=script&lang=js&"
import style0 from "./TableDraft.vue?vue&type=style&index=0&id=346b5c11&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports